// currencyToFloat should also be migrated here at some point

type CentDisplay = 'SHOW_CENTS' | 'HIDE_CENTS' | 'HIDE_ZERO_CENTS';

/**
 * New version of our formatCurrency that supports different cent display modes.
 * When we remove the old _misc.js, I think we should change all code to use this method.
 * @param num The number to format
 * @param centDisplayMethod When to display cents. Defaults to always showing cents.
 * @returns The formatted currency
 */
export function formatCurrencyV2(num: string | number, centDisplayMethod: CentDisplay = 'SHOW_CENTS'): string {
    if (typeof num === 'string') {
        num = parseInt(num.replace(/[$,]/g, ''), 10);
    } else if (isNaN(num)) {
        num = 0;
    }

    const sign = (num === (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    const cents = num % 100;
    num = Math.floor(num / 100).toString();
    const paddedCents = (cents < 10 ? '0' : '') + cents;

    for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
    }

    const hideCents = centDisplayMethod === 'HIDE_CENTS' ||
            (centDisplayMethod === 'HIDE_ZERO_CENTS' && cents === 0);
    return (((sign) ? '' : '-') + '$' + num + (hideCents ? '' : '.' + paddedCents));
}
